import * as React from 'react'
import { Col, FormGroup, ControlLabel } from 'react-bootstrap'

export interface ItemRowProps {
	name: string | number | symbol
	description?: string | JSX.Element
	validationState?: 'error' | 'warning' | 'success'
	fullWide?: boolean
	columnWidth?: number
	columnWidthLg?: number
	offset?: number
	offsetLg?: number
	rowStyle?: React.CSSProperties
	children?: React.ReactNode
}

const ItemRow = ({
	name,
	description,
	validationState,
	fullWide,
	columnWidth,
	columnWidthLg,
	offset,
	offsetLg,
	rowStyle,
	children,
}: ItemRowProps) => {
	return (
		<FormGroup className="row" controlId={name.toString()} validationState={validationState} style={rowStyle}>
			<Col
				md={columnWidth ? columnWidth : fullWide ? 12 : 10}
				lg={columnWidthLg ? columnWidthLg : fullWide ? 12 : 8}
				mdOffset={offset ?? (!fullWide ? 1 : undefined)}
				lgOffset={offsetLg ?? (!fullWide ? 2 : undefined)}
			>
				{description && <ControlLabel>{description}</ControlLabel>}
				{children}
			</Col>
		</FormGroup>
	)
}

export default ItemRow
